var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.92847,
    y1: 3.78571,
    x2: 18.0713,
    y2: 3.78571,
    stroke: "#273561",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: "2px"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.92847,
    y1: 10.2143,
    x2: 18.0713,
    y2: 10.2143,
    stroke: "#273561",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: "2px"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1.92847,
    y1: 16.6429,
    x2: 18.0713,
    y2: 16.6429,
    stroke: "#273561",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: "2px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburger);
export default __webpack_public_path__ + "static/media/icon_hamburger.4a31f625a14fb27d6defb6b72433ef25.svg";
export { ForwardRef as ReactComponent };